export type Uuid = `${string}-${string}-${string}-${string}-${string}`;

/**
 * Generate a RFC 4122 UUID v4.
 * Uses crypto.randomUUID() when available (secure contexts / HTTPS).
 * Falls back to a Math.random()-based implementation for HTTP environments.
 */
export function createUuid(): Uuid {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const randomIndex = (char === 'x') ? (
      // Hex 0-9 or A-F.
      Math.random() * 16
    ) : (
      // Hex 8-9 or A-B.
      8 + (Math.random() * 4)
    );

    return Math.floor(randomIndex).toString(16);
  }) as Uuid;
}
